export default {
    navigationBarTitleText: intl.get('padPage.mine.resetPasswords')
};
